function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { qs } from "scripts/data_utils/domHelpers";
import emailValidation from "scripts/data_utils/email_validation";
import formDataFetch from "scripts/data_utils/formDataFetch";
import showNotification from "scripts/dom_utils/notification";
import { throwError } from "scripts/data_utils/throwError";
import { getGlobal } from "scripts/utils/global";
import PopupPrompt from "./popup_prompt";

class LoginPopup extends PopupPrompt {
  constructor(el, values) {
    super(el);

    _defineProperty(this, "validationForm", e => {
      e.preventDefault();

      if (!this.fields.emailField.value) {
        this.showFieldError(this.form, "email", "Введите e-mail");
        return;
      }

      if (!emailValidation(this.fields.emailField.value)) {
        this.showFieldError(this.form, "email", "Не похоже на e-mail");
        return;
      }

      this.sendForm();
    });

    _defineProperty(this, "sendForm", () => {
      const data = {
        email: this.fields.emailField.value
      };
      formDataFetch("/account/password_reset/", data).then(response => {
        if (response.errors.length) {
          this.showAllErrors(response.errors);
        } else {
          var _getGlobal;

          this.hidePopup();
          (_getGlobal = getGlobal("dataLayer")) === null || _getGlobal === void 0 ? void 0 : _getGlobal.push({
            event: "Reestablish"
          });
          showNotification({
            text: "На указанную почту отправлено письмо c инструкцией по сбросу пароля",
            status: "success"
          });
        }
      }).catch(error => throwError({
        error
      }));
    });

    _defineProperty(this, "body", `
  <div class="modal-wrapper__title">
    Восстановление пароля
  </div>

  <form class="js-form" method="post">
    <p class="modal-wrapper__text">
      Введите адрес электронной почты, с&nbsp;помощью которого вы&nbsp;регистрировались на&nbsp;сайте. Письмо с&nbsp;инструкцией
      по&nbsp;восстановлению пароля придет в&nbsp;течение минуты.
    </p>
    <label for="email" class="text-input">
    <span class="text-input__text">Ваша электронная почта</span>
      <input class="text-input__input js-email" type="email" value=""/>
      <div class="modal-wrapper__error js-error-container form-error-email" style="display:none"></div>
    </label>
    <button class="button button--big button--primary">Восстановить пароль</button>

    <div>
      <div class="modal-wrapper__error js-error-container js-__all__ form-error-__all__" style="display:none"></div>
    </div>
  </form>
  `);

    this.init();
    this.form = qs(".js-form", this.dialogBox);
    this.fields = {
      emailField: qs(".js-email", this.form)
    };
    this.fields.emailField.value = values.email;
    this.form.addEventListener("submit", this.validationForm);
    this.hideErrorOnClickOnField();
  }

}

export default LoginPopup;